import { useEffect, useState } from "react"
import { getModulos } from "src/services/admin/resident"

const useComplexModules = conjuntoId => {
  const [modulos, setModulos] = useState({})

  useEffect(() => {
    if (!conjuntoId) return undefined

    return getModulos(
      {
        next: querySnapshot => {
          setModulos(querySnapshot.data() || {})
        },
      },
      conjuntoId
    )
  }, [conjuntoId])

  return modulos
}

export default useComplexModules
